import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Card from './Card';

const formatDate = (string, format) => {
  let date = new Date(string);
  let options = { month: 'short', year: 'numeric' };

  if (format === 'MYD') {
    // MYD is Event which needs time included or dates will be behind 1 day
    date = new Date(`${string} 00:00:00`);
    options = { month: 'short', day: '2-digit', year: 'numeric' };
  }

  const formatedDate = date.toLocaleDateString('en-US', options).replace(',', '');
  return formatedDate;
};

const pastDate = (date) => {
  const today = new Date();
  const newDate = new Date(date);

  if (today > newDate) {
    return true;
  }

  return false;
};

export default class RelatedNewsEventsBody extends Component {
  render() {
    const {
      terms, data, ready,
    } = this.props;
    const getTerm = (tid) => {
      let termName = '';
      terms.forEach((term, i) => {
        if (term.tid === `${tid}`) {
          termName = terms[i].name;
        }
      });
      return termName;
    };

    if (!ready) return null;

    if (ready && data.length === 0) return null;

    const childElements = data.map(card => (
      <Card
        key={card.nid[0].value}
        type={typeof card.type[0] === 'undefined' ? '' : card.type[0].target_id}
        theme={typeof card.field_theme[0] === 'undefined' ? '' : getTerm(card.field_theme[0].target_id)}
        fieldType={typeof card.field_type[0] === 'undefined' ? '' : getTerm(card.field_type[0].target_id)}
        color={typeof card.field_header_background[0] === 'undefined' ? '' : card.field_header_background[0].color}
        image={card.field_header_image instanceof Array || typeof card.field_header_image === 'undefined' ? 'https://via.placeholder.com/370x480.png' : card.field_header_image}
        newsTitle={!card.field_news_title || typeof card.field_news_title[0] === 'undefined' ? '' : card.field_news_title[0].value}
        title={typeof card.title[0].value === 'undefined' ? '' : card.title[0].value}
        date={typeof card.published_at[0] === 'undefined' ? '' : formatDate(card.published_at[0].value)}
        alumnus={typeof card.alumni === 'undefined' ? {} : card.alumni}
        url={`${card.path[0].alias}`}
        featured={typeof card.sticky[0] === 'undefined' ? '' : card.sticky[0].value}
        intro={typeof card.field_intro_paragraph_wysiwyg[0] === 'undefined' ? '' : card.field_intro_paragraph_wysiwyg[0].value}
        description={typeof card.field_description[0] === 'undefined' ? '' : card.field_description[0].value}
        eventStartDate={!card.field_event_start_date || typeof card.field_event_start_date[0] === 'undefined' ? '' : card.field_event_start_date}
        eventEndDate={!card.field_event_end_date || typeof card.field_event_end_date[0] === 'undefined' ? '' : card.field_event_end_date}
        eventSubType={!card.field_event_subtype || typeof card.field_event_subtype[0] === 'undefined' ? '' : getTerm(card.field_event_subtype[0].target_id)}
        newsSubType={!card.field_news_subtype || typeof card.field_news_subtype[0] === 'undefined' ? '' : getTerm(card.field_news_subtype[0].target_id)}
        pastEvent={!card.field_event_end_date || typeof card.field_event_end_date[0] ? pastDate(card.field_event_end_date) : false}
      />
    ));

    return (
      <div className="related-news-events-body">
        <div>
          <h2>Alumni News & Events</h2>
        </div>
          <div className="related-news-events-grid">
            {childElements}
          </div>
      </div>
    );
  }
}

RelatedNewsEventsBody.defaultProps = {
  module: false,
  ready: false,
  pastEvent: false,
};

RelatedNewsEventsBody.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.object,
  ).isRequired,
  terms: PropTypes.arrayOf(
    PropTypes.object,
  ).isRequired,
  module: PropTypes.bool,
  ready: PropTypes.bool,
};
